import { createRequestActions as request } from 'store/actionCreators'
import { createAction } from 'redux-actions'

export const getUpcomingActivities = request('DIFFERENT_ACTIVITIES/GET_UPCOMING_ACTIVITIES', () => ({
  request: {
    url: `protrack-levels-progress/try-different-activity/upcoming`,
  },
}))

export const getPreviousActivities = request('DIFFERENT_ACTIVITIES/GET_PREVIOUS_ACTIVITIES', () => ({
  request: {
    url: `protrack-levels-progress/try-different-activity/previous`,
  },
}))

export const tryDifferentActivity = request('DIFFERENT_ACTIVITIES/TRY_DIFFERENT_ACTIVITY', activityId => ({
  request: {
    url: `protrack-levels-progress/try-different-activity/${activityId}`,
    method: 'POST',
  },
  activityId,
}))

export const setActivitiesLoadStatusToDefault = createAction('DIFFERENT_ACTIVITIES/SET_ACTIVITIES_LOAD_STATUS')

export const setFalsePendingStatus = createAction('DIFFERENT_ACTIVITIES/SET_FALSE_PENDING_STATUS')
